export * from './hours-types.malou';
